import React, { useState, useEffect } from "react";
import { InputModal } from "./Modal";
import PropTypes from "prop-types";
// import { useNavigate, Link } from "react-router-dom";
import { useNavigate, Link } from "react-router-dom";
import "./SideNav.css";
import SvgNoteIcon from "../icons/iconComponents/NoteIcon";
import SvgStarIcon from "../icons/iconComponents/StarIcon";
// import SvgNewFolderIcon from "../icons/iconComponents/NewFolderIcon";
// import SvgAddIcon from "../icons/iconComponents/AddIcon";
import SvgNoteViewIcon from "../icons/iconComponents/NoteViewIcon";
import SvgWindowCloseIcon from "../icons/iconComponents/SvgWindowCloseIcon";
import { commitLocalUpdate } from "react-relay";
import { useTheme } from "../contexts/ThemeContext";
import { useMediaQuery } from "react-responsive";
import environment, { updateLocalSetting } from "../Environment";
import AllNotesIcon from "../icons/AllNotesIcon.svg";

import TreeContainer from "./TreeContainer";
import Spinner from "../Spinner";
import ReactTooltip from "react-tooltip";
import NoteViewContainer from "../components/NoteViewContainer";
// import ProductDemoModal from "../components/ProductDemoModal";

import {
    Add32,
    Notebook32,
    FolderAdd32,
    Favorite32,
    Idea32,
    Edit32,
} from "@carbon/icons-react";

SideNav.propTypes = {
    isActivated: PropTypes.bool,
    setIsActivated: PropTypes.func,
};

function SideNav(props) {
    let [isModalActive, setIsModalActive] = useState(false);
    const navigate = useNavigate();
    const [isNoteView, setIsNoteView] = useState(false);
    const [isBookmarkView, setIsBookmarkView] = useState(false);
    const [isTreeView, setIsTreeView] = useState(false);
    const [isNotes, setIsNotes] = useState(false);
    const isSmallScreen = useMediaQuery({
        query: "(max-device-width: 450px)",
    });

    const { isNoteViewActivated, isDetailView, isAddSourcePageActivated } =
        props.settings;
    const theme = useTheme();
    const [isCarausalActive, setIsCarousalActive] = useState(false);

    // const x = first_time_user ? 'first time user' : 'experienced user';

    function onAddSourceClick(e) {
        e.preventDefault();

        if (isSmallScreen) {
            updateLocalSetting("isNavActivated", false);
        }

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isAddSourcePageActivated");
        });
        navigate("/add-source");
    }

    function onShowCarousalClick(e) {
        e.preventDefault();
        // setIsCarousalActive(true);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isProductDemoActivated");
        });
    }

    function onNoteViewClick(e) {
        e.preventDefault();
        setIsBookmarkView(false);

        if (isSmallScreen) {
            updateLocalSetting("isNavActivated", false);
        }

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isPostNoteView");
            record.setValue(false, "isBookmarkView");
            record.setValue("Posts with Notes", "metaDescription");
            record.setValue("", "metaSourceName");

            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
            record.setValue(false, "allSubscriptions");
        });

        navigate("/home");
    }

    function onBookmarkClick(e) {
        e.preventDefault();
        if (isSmallScreen) {
            updateLocalSetting("isNavActivated", false);
        }
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isBookmarkView");
            record.setValue("Bookmarked Posts", "metaDescription");
            record.setValue("", "metaSourceName");
            record.setValue(false, "isPostNoteView");

            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
            record.setValue(false, "allSubscriptions");

            record.setValue("{}", "tagData");
            navigate("/home");
        });
    }

    function onWindowCloseClick(e) {
        e.preventDefault();
        updateLocalSetting("isNavActivated", false);
    }

    function onAllArticlesClick(e) {
        e.preventDefault();
        let metaSourceName = "All Subscriptions";
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");

            record.setValue(false, "isParent");
            record.setValue(metaSourceName, "metaSourceName");
            record.setValue("Articles from ", "metaDescription");
            record.setValue(false, "isBookmarkView");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedSentimentPostIds");
            record.setValue([], "selectedLeads");
            record.setValue(true, "allSubscriptions");
            record.setValue(metaSourceName, "metaSourceName");
            record.setValue("Articles from ", "metaDescription");
            record.setValue(metaSourceName, "metaSourceName");
            record.setValue(false, "isBookmarkView");
            record.setValue(false, "isPostNoteView");
            record.setValue(false, "isAdvancedSearch");

            record.setValue(false, "isRightNavActivated");
            record.setValue("{}", "tagData");
            
            record.setValue(false, "isAddSourcePageActivated");
        });

        if (isSmallScreen) {
            updateLocalSetting("isNavActivated", false);
        }

        navigate("/home");
    }

    function onManageClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isAccountView");
            record.setValue(true, "isSubListView");
            record.setValue(false, "isProfileView");
            navigate("/settings");
        });
    }

    let navbarState = props.isActivated ? "open" : "closed";

    return (
        <div
            id="mySidebar"
            className={`sidebar theme-${theme.dark} main-nav-${navbarState}`}
        >
            <ReactTooltip delayShow={400} backgroundColor="#626262" />
            <div className={`sidenav-content theme-${theme.dark}`}>
                <div className={`sidenav-items`}>
                    <div className="sidenav-close-icon">
                        <SvgWindowCloseIcon onClick={onWindowCloseClick} />
                    </div>
                    <div
                        className={`sidenav-main-categories sidenav-group`}
                    ></div>

                    {isNoteView ? (
                        <div className="note-container">
                            <h3> Notes </h3>
                            <NoteViewContainer settings={props.settings} />
                        </div>
                    ) : (
                        <div>
                            <div
                                className={`all-articles theme-${theme.paragraph}`}
                                onClick={onAllArticlesClick}
                            >
                                All Subscriptions
                            </div>

                            <TreeContainer settings={props.settings} />
                        </div>
                    )}

                    {isModalActive ? (
                        <div>
                            <InputModal
                                title="Create a new folder"
                                setIsModalActive={setIsModalActive}
                                isModalActive={isModalActive}
                            />
                        </div>
                    ) : null}
                </div>
            </div>

            <div className={`source-add-btn-container theme-${theme.dark}`}>
                <div className="icon-box">
                    <Add32
                        onClick={onAddSourceClick}
                        className="carbon-icon my-second-step"
                        aria-label="Add"
                    />
                    <label>Add Feed</label>
                </div>

                <div className="icon-box">
                    {!isAddSourcePageActivated ? (
                        <>
                            <Idea32
                                onClick={onShowCarousalClick}
                                className="tips-icon"
                            />

                            <label>Tips</label>
                        </>
                    ) : (
                        <>
                            <Edit32 onClick={onManageClick} />
                            <label>Manage</label>
                        </>
                    )}
                </div>

                <div className="icon-box">
                    <Favorite32
                        onClick={onBookmarkClick}
                        className="carbon-icon my-third-step"
                        aria-label="Notes"
                    />
                    <label>Bookmarks</label>
                </div>
                {isDetailView ? (
                    <SvgNoteViewIcon size={30} />
                ) : (
                    //   <img width={30} src={AllNotesIcon} alt="" onClick={onNoteViewClick} />
                    <div className="icon-box">
                        <Notebook32
                            onClick={onNoteViewClick}
                            className="carbon-icon my-fourth-step"
                            aria-label="Notes"
                        />
                        <label>Notes</label>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SideNav;
